// Load Feedback Survey: questions come from the shipper's form, falling back to the carrier's
// (survey_questions/survey_responses); only the photo label/hint helpers are fixed here.

import { OUTBOUND_MANIFEST_TYPES } from '@/constants/manifestStatuses';

export const getLoadPhotosLabel = (type) =>
    OUTBOUND_MANIFEST_TYPES.includes(type) ? 'Trailer Loading Photos' : 'Trailer Unloading Photos';

export const getLoadPhotosHint = (type) =>
    OUTBOUND_MANIFEST_TYPES.includes(type)
        ? 'At least 3 photos of truck required (beginning, middle, and end of loading).'
        : 'At least 3 photos of truck required (beginning, middle, and end of unloading).';
